import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import { motion } from 'framer-motion';
import { Diamond } from '@/components/Diamond';
import { Button } from '@/components/ui/button';
import Title from '@/components/ui/title';
import { assets } from '@/lib/assets';
import PageRoutes from '@/lib/routing/PageRoutes';
import { playSound } from '@/lib/utils/playSound';
import { gameDataContext } from '@/providers/GameDataProvider';

export default function PageThanks() {
  const { t } = useTranslation();
  const { totalScore } = useContext(gameDataContext);

  useEffect(() => {
    playSound(assets.sounds.outroMusic, { loop: false });
  }, []);

  return (
    <div className="flex h-screen flex-col justify-center">
      <motion.img
        src="content/images/heroes.webp"
        alt="hero"
        className="-mb-10 -mt-10 max-h-[60vh] min-h-0 w-full flex-shrink object-contain"
        initial={{ opacity: 0, scale: 0.5, y: 100 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.2, ease: 'easeOut' }}
      />
      <motion.div
        className="flex-col items-center px-10"
        initial={{ opacity: 0, scale: 0.5, y: 100 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4, ease: 'easeOut' }}
      >
        <Diamond value={totalScore} className="h-20" />
      </motion.div>

      <motion.div
        className="flex-col px-10 pb-20 pt-1 text-center md:pt-4"
        initial={{ opacity: 0, scale: 0.5, y: 100 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4, ease: 'easeOut' }}
      >
        <Title i18nKey="thanks.title" className="text-4xl" />
        <motion.div
          className="flex-grow flex-col justify-center pt-10"
          initial={{ opacity: 0, scale: 0.5, y: 100 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6, ease: 'easeOut' }}
        >
          <NavLink to={PageRoutes.outro.path}>
            <Button variant="secondary" className="w-60">
              {t('thanks.button')}
            </Button>
          </NavLink>
        </motion.div>
      </motion.div>
    </div>
  );
}
